"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_infinite_scroller_1 = __importDefault(require("react-infinite-scroller"));
var grid_1 = require("./grid");
var Infinite = function (_a) {
    var children = _a.children, loadMore = _a.loadMore, hasMore = _a.hasMore, isLoading = _a.isLoading, _b = _a.pageSize, pageSize = _b === void 0 ? 10 : _b, _c = _a.reverse, reverse = _c === void 0 ? false : _c;
    var fetchMore = function (_) { return loadMore(pageSize); };
    var scrollEl = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (!reverse || !scrollEl || !scrollEl.current)
            return;
        scrollEl.current.scrollIntoView();
    }, [scrollEl, reverse]);
    return (react_1.default.createElement(react_infinite_scroller_1.default, { hasMore: hasMore, loadMore: fetchMore, initialLoad: false, isReverse: reverse },
        react_1.default.createElement(grid_1.Container, { key: "list", direction: reverse ? 'column-reverse' : 'column' },
            reverse ? react_1.default.createElement("div", { key: "scroll-el", ref: scrollEl }) : null,
            children)));
};
exports.default = Infinite;
//# sourceMappingURL=InfiniteScroll.js.map